<template>
  <div class="app-wrapper">
  <navbar></navbar>
  <div class="main-container">
    <app-content></app-content>
  </div>
  <FootComponent></FootComponent>
  </div>
</template>

<script>
import { Navbar, AppContent } from '@/views/layouts/components'
import FootComponent from '@/components/foot.vue'

export default {
  name: 'AppLayout',
  components: {
    Navbar,
    AppContent,
    FootComponent
  }
}
</script>

<style scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
.main-container {
  text-align: center;
  margin-top: 8em;
  min-height: 50vh;
}
</style>
